import api from "./axios";

class serviceProductionOrderItem {
  async save(product) {
    const { data } = await api.post(`/production-order-item`, product)
    return data
  }

  async update(id, product) {
    const { data } = await api.put(`/production-order-item/${id}`, product)
    return data
  }

  async findByIdProductionOrderPerTypeItem(idProductionOrder, typeItem) {
    const { data } = await api.get(`/production-order-item/find/items/by/production-order/${idProductionOrder}?typeItem=${typeItem}`)
    return data
  }

  async delete(id) {
    await api.delete(`/production-order-item/${id}`)
  }

  async replaceAll(currentProd, prevProdId, saleId, priceType) {
    await api.post(`/production-order-item/replace-all/${prevProdId}/${saleId}?priceType=${priceType}`, currentProd)
  }
}

export default new serviceProductionOrderItem()